import { jsx as O } from "react/jsx-runtime";
import b, { useState as c } from "react";
const T = {
  allCheckboxChecked: 0,
  checkboxCheckedValues: [],
  setCheckboxChecked: (s, l) => {
  },
  setAllCheckboxChecked: (s) => {
  },
  assignCheckboxesDefaultValues: (s) => {
  },
  showOptionsEnabled: !1,
  setShowOptionsEnabled: (s) => {
  },
  showCheckboxEnabled: !1,
  setShowCheckboxEnabled: (s) => {
  },
  isStickyColumnEnabled: !1,
  setIsStickyColumnEnabled: (s) => {
  },
  showAllTableDataContent: !0,
  setShowAllTableDataContent: (s) => {
  },
  sortOrder: {
    columnNumber: 0,
    value: "asc"
  },
  setSortOrder: (s) => {
  }
}, I = b.createContext(
  T
), g = ({ children: s }) => {
  const [l, n] = c([]), [d, C] = b.useState({
    columnNumber: 0,
    value: "asc"
  }), [k, r] = c(!1), [u, x] = c(!1), [i, v] = c(!1), [f, p] = c(0), [S, E] = c(!0), m = (e, o) => {
    const h = l.findIndex(
      (a) => a.id === e
    );
    if (l[h]?.disabled)
      return;
    const t = [...l];
    h >= 0 ? (t.splice(h, 1, {
      id: e,
      value: o,
      disabled: !1
    }), n(t)) : (t.push({ id: e, value: o }), n(t));
  }, w = (e = []) => {
    const o = [...l, ...e];
    n(o);
  }, V = (e, o = []) => {
    const t = [...o, ...l].map((a) => {
      const D = a?.disabled ? a.value : e;
      return { id: a.id, value: D, disabled: !!a?.disabled };
    });
    n(t), p(e);
  }, A = (e) => {
    x(e);
  };
  return /* @__PURE__ */ O(
    I.Provider,
    {
      value: {
        allCheckboxChecked: f,
        checkboxCheckedValues: l,
        setCheckboxChecked: m,
        setAllCheckboxChecked: V,
        assignCheckboxesDefaultValues: w,
        showOptionsEnabled: k,
        setShowOptionsEnabled: r,
        showCheckboxEnabled: u,
        setShowCheckboxEnabled: A,
        isStickyColumnEnabled: i,
        setIsStickyColumnEnabled: v,
        showAllTableDataContent: S,
        setShowAllTableDataContent: E,
        sortOrder: d,
        setSortOrder: C
      },
      children: s
    }
  );
};
export {
  I as TableContext,
  I as TableContextV1,
  g as TableProvider,
  g as TableProviderV1
};
